export default __webpack_public_path__ + "static/media/belgaWhite.ab1f1185.svg";